import React from 'react';

// Cream/ink toggle used by Away players pay blinds and Blind Timer.
// hideLabel: knob only, for a grey caps heading row. Labeled: 44px row.

export default function InkSwitch({
  enabled = false,
  onChange,
  disabled = false,
  hideLabel = false,
  label,
  ariaLabel,
  testId,
}) {
  const on = enabled === true;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel || label}
      disabled={disabled}
      onClick={() => onChange?.(!on)}
      data-testid={testId}
      data-on={on ? 'true' : 'false'}
      style={{ WebkitTapHighlightColor: 'transparent' }}
      className={
        hideLabel
          ? 'inline-flex flex-shrink-0 items-center p-0 bg-transparent border-0 disabled:opacity-40'
          : 'w-full flex items-center justify-between gap-3 min-h-[44px] px-0 bg-transparent border-0 text-left disabled:opacity-40'
      }
    >
      {hideLabel ? null : (
        <span className="text-[14px] font-medium text-ink leading-tight">
          {label}
        </span>
      )}
      <span
        aria-hidden="true"
        className={`relative inline-block flex-shrink-0 w-11 h-7 rounded-full transition-colors ${
          on ? 'bg-ink' : 'bg-line'
        }`}
      >
        <span
          className={`absolute top-0.5 w-6 h-6 rounded-full bg-cream shadow-sm transition-transform ${
            on ? 'left-[18px]' : 'left-0.5'
          }`}
        />
      </span>
    </button>
  );
}
